import { useCallback } from "react";
import { useMutation } from "@apollo/client";

import { ClientVerifyPhoneNumberDocument } from "../../__generated__/graphql";

export function useClientVerifyPhoneNumber() {
  const [mutate, state] = useMutation(ClientVerifyPhoneNumberDocument);

  /** Sends a code and resolves with its expiry, as the server formats it. */
  const verifyPhoneNumber = useCallback(
    async (phone: string, onSignUp?: boolean): Promise<string | undefined> => {
      const { data } = await mutate({
        variables: { input: { phone, onSignUp, enableWhatsappOtp: true } },
      });
      const result = data?.clientVerifyPhoneNumber?.result;
      if (result && "message" in result) throw new Error(result.message);
      return result && "expiresAt" in result ? result.expiresAt : undefined;
    },
    [mutate],
  );

  return [verifyPhoneNumber, state] as const;
}
